import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { listEncounters } from 'src/modules/ambient_solo/store/actions/encounter';

export * from './useGetEncounterList';
export * from './useGetEncounterDetails';
export * from './useStartEncounter';
export * from './useGetEncounterDocumentList';
export * from './useLinkEncounterDocuments';
export * from './useUpdateEncounterDetails';
export * from './useTagEncounter';
export * from './useCompleteEncounter';
export * from './useRegenerateEncounterSummary';
export * from './useCreateEncounter';
export * from './useGetEncounterByEHRID';
export * from './useGetEncounterByEhrAppointmentId';
export * from './useUpdateEncounterByEhrId';
export * from './useSyncEncounter';

export const useLegacyEncounterStore = () => {
  const dispatch = useDispatch();

  const updateEncounterList = useCallback(
    async (legacySearchFilters: unknown) => {
      await dispatch(listEncounters(legacySearchFilters) as any);
    },
    [dispatch]
  );

  return { updateEncounterList };
};
